<ng-container *ngIf="items?.length">
  <json-ld [json]="breadcrumbJs"></json-ld>
  <div class="fs-sm px-2">
    <ng-container *ngFor="let item of items|slice:0:items.length-hideLast;let i=index">
      <i *ngIf="i" class="fas fa-angle-left mx-1"></i>
      <a [routerLink]="item.link" class=" py-1">{{item.title}}</a>
    </ng-container>
  </div>
</ng-container>